import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'setting-';

export default {
    path: '/setting',
    name: 'setting',
    redirect: {
        name: `${pre}user`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'polymerization',
            name: `${pre}polymerization`,
            meta: {
                ...meta,
                title: '服务中台'
            },
            component: () => import('@/pages/account/polymerization')
        },
        {
            path: 'polymerization1',
            name: `${pre}polymerization1`,
            meta: {
                ...meta,
                title: '主控台'
            },
            component: () => import('@/pages/account/polymerization')
        },
        {
            path: 'user',
            name: `${pre}user`,
            meta: {
                ...meta,
                title: '个人中心'
            },
            component: () => import('@/pages/setting/user')
        },
        {
            path: 'account',
            name: `${pre}account`,
            meta: {
                ...meta,
                title: '个人设置'
            },
            component: () => import('@/pages/setting/account')
        }
    ]
};
